<template>
  <div class="drawer-box">
    <h1 class="drawer-title">子账号信息</h1>
    <div class="column">
      <span class="line"></span>
      <span style="vertical-align: middle">基本信息</span>
    </div>
    <div class="drawer-content">
      <div class="item">
        <div class="label">用户名：</div>
        <span class="content">{{ drawerObj.account  }}</span>
      </div>
      <div class="item">
        <div class="label">创建时间：</div>
        <span class="content">{{ drawerObj.createTime  }}</span>
      </div>
      <div class="item">
        <div class="label">最后登录时间：</div>
        <span class="content">{{ drawerObj.loginTime  }}</span>
      </div>
    </div>
    <div class="column">
      <span class="line"></span>
      <span style="vertical-align: middle">权限信息</span>
    </div>
    <div class="drawer-content">
      <div class="item">
        <div class="label">所属用户组：</div>
        <span class="content"><span v-for="item in drawerObj.checkedRole" :key="item.id">{{item.roleName}}</span></span>
      </div>
      <div class="item">
        <div class="label">组内权限：</div>
        <span class="content"><span class="content-item" v-for="(item,index) in permissions" :key="index">{{item}}</span></span>
      </div>
    </div>
    <div class="column">
      <span class="line"></span>
      <span style="vertical-align: middle">统计信息</span>
    </div>
    <div class="drawer-content">
      <div class="item">
        <div class="label" style="width: 55px;">时间：</div>
        <div class="time-box"></div>
          <DatePicker
            type="date"
            placeholder="年/月/日"
            style="width: 132px"
            @on-change="beginTimeChange"
            :value="beginTime"
          ></DatePicker>
          <div style="margin: 0 4px;line-height: 32px;">-</div>
          <DatePicker
            type="date"
            placeholder="年/月/日"
            style="width: 132px"
            @on-change="dateChange"
            :options='endTimeOptions'
            :value="endTime"
          ></DatePicker>
      </div>
      <div class="drawer-table">
        <Table :loading="loading" :columns="columns" :data="tableData" :border="true"></Table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['drawerObj'],
  created() {
    var myDate = new Date(); // 获取当天日期
    this.endTime = this.$global.transferDay(myDate)
    myDate.setDate(myDate.getDate() - 6); // 获取七天前的日期
    this.beginTimeChange(this.$global.transferDay(myDate))
    this.getPermissions()
    this.getDetail()
  },
  data() {
    return {
      loading: false,
      beginTime: '',
      endTime: '',
      endTimeOptions: {},
      columns: [
        {
            "title": "上传总量(篇)",
            "key": "totalRelaseNum",
            "width": 80,
            "align": 'center',
        },{
            "title": "审核中(篇)",
            "key": "totalAuditNum",
            "width": 65,
            "align": 'center',
        },{
            "title": "已通过(篇)",
            "key": "totalPassNum",
            "width": 65,
            "align": 'center',
        },{
            "title": "未通过(篇)",
            "key": "totalNotPassNum",
            "width": 65,
            "align": 'center',
        },{
            "title": "下架(篇)",
            "key": "totalOffNum",
            "width": 50,
            "align": 'center',
        },{
            "title": "退回次数",
            "key": "returnNum",
            "width": 60,
            "align": 'center',
        },{
            "title": "平均单篇修改次数",
            "key": "averageReturn",
            "align": 'center',
        },{
            "title": "单篇修改最高次数",
            "key": "maxUpdNum",
            "align": 'center',
        },{
            "title": "发布率",
            "key": "releaseRate",
            "width": 50,
            "align": 'center',
        },
      ],
      tableData: [],
      permissions: [],
    }
  },
  methods: {
    
      
    dateChange(e) {
      this.endTime = e
      if (this.beginTime) {
        this.getDetail()
      }
    },
    beginTimeChange(e) {
      var beginTime = new Date(e).getTime()
      if (this.endTime !== '') {
        var endTime = new Date(this.endTime).getTime()
        if (beginTime > endTime) this.endTime = ''
      }
      // 给结束时间日期选择范围增加限制不超过开始时间
      this.endTimeOptions = {
        disabledDate (date) {
          return date && date.valueOf() < beginTime;
        }
      }
      this.beginTime = e
    },
    // 获取组权限
    async getPermissions() {
      console.log(this.drawerObj,'this.drawerObj');
      if (this.drawerObj.checkedRole.length === 0) return
      const res = await this.$apis.userServe.getJurisdiction({
        groupId: this.drawerObj.checkedRole[0].id,
      });
      res.content.map[0].forEach(item => {
        if (item.flag) {
          res.content.map[item.id].forEach(i => {
            if (i.flag) {
              if (item.name === '发布') {
                this.permissions.push(i.name+'发布')
              } else {
                this.permissions.push(i.name)
              }
            }
          })
        }
      });
    },
    async getDetail() {
      this.loading = true
      const res = await this.$apis.userServe.getSonDetails({
        type: this.drawerObj.subType,
        userId: this.drawerObj.id,
        beginTime: this.beginTime,
        endTime: this.endTime,
      });
      this.tableData = [res.data]
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer-box {
  padding: 34px;
  .drawer-title {
    margin-bottom: 45px;
    padding-left: 3px;
    font-size: 26px;
    font-weight: 400;
    color: #333333;
  }
  .column {
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #3c3c3c;
    .line {
      margin-right: 14px;
      width: 4px;
      height: 16px;
      background: #4343c1;
    }
  }
  .drawer-content {
    margin: 25px 0 60px;
    .item {
      display: flex;
      .label {
        margin-right: 15px;
        width: 100px;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        line-height: 30px;
      }
      .content {
        flex: 1;
        font-size: 14px;
        color: #000000;
        line-height: 30px;
        .content-item {
          &::after {
            content: '、';
          }
          &:last-child {
            &::after {
              content: '';
            }
          }
        }
      }
    }
    .drawer-table {
      margin-top: 26px;
      &::v-deep .ivu-table th {
        background-color: #fff;
      }
      &::v-deep .ivu-table-cell {
        padding: 0;
        font-size: 12px;
        font-weight: normal;
      }
    }
  }
}
</style>